import React from 'react';
import ProjectsContainer from "../containers/ProjectsContainer";
import HeaderContainer from "../containers/HeaderContainer"

const Projects = (props) => {
  return (
    <div>
      <HeaderContainer />
      <ProjectsContainer />
    </div>
  );
};

export default Projects;
